<h2 mat-dialog-title>{{contentTitle | translate}}</h2>

<mat-dialog-content>
  <div class="pt-2 pb-3">
    <section class="mt-1 mb-3 rounded m-auto w-100" id="section" >
      <form [formGroup]="contentDialogForm">

        @if (contentDataType=='text') {
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{'pass.text' | translate}}</mat-label>
            <input formControlName="text" type="text" matInput placeholder="{{'pass.text' | translate}}">
          </mat-form-field>
        }

        @if (contentDataType=='image') {
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{'pass.url' | translate}}</mat-label>
            <input formControlName="url" type="text" matInput placeholder="{{'pass.url' | translate}}">
          </mat-form-field>
        }

        @if (contentDataType=='text') {
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{'pass.composed.font' | translate}}</mat-label>
            <mat-select formControlName="font">
              @for (font of fontOptions; track font) {
                <mat-option [value]="font.value">{{ font.translation | translate }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        }

        @if (contentDataType=='hstack' || contentDataType=='vstack') {
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{'pass.composed.spacing' | translate}}</mat-label>
            <input formControlName="spacing" type="number" matInput placeholder="{{'pass.composed.spacing' | translate}}" min="0">
          </mat-form-field>
        }

        @if (contentDataType=='vstack') {
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{'pass.composed.horizontalAlignment' | translate}}</mat-label>
            <mat-select formControlName="horizontalAlignment">
              @for (horizontalAlignment of horizontalAlignmentOptions; track horizontalAlignment) {
                <mat-option [value]="horizontalAlignment.value">{{ horizontalAlignment.translation | translate }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        }

        @if (contentDataType=='hstack') {
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{'pass.composed.verticalAlignment' | translate}}</mat-label>
            <mat-select formControlName="verticalAlignment">
              @for (verticalAlignment of verticalAlignmentOptions; track verticalAlignment) {
                <mat-option [value]="verticalAlignment.value">{{ verticalAlignment.translation | translate }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        }

        <mat-form-field appearance="outline" class="w-100">
          <mat-label>{{'pass.composed.width' | translate}}</mat-label>
          <input formControlName="width" type="number" matInput placeholder="{{'pass.composed.width' | translate}}" min="0">
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-100">
          <mat-label>{{'pass.composed.height' | translate}}</mat-label>
          <input formControlName="height" type="number" matInput placeholder="{{'pass.composed.height' | translate}}" min="0">
        </mat-form-field>

      </form>
    </section>
  </div>


</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button style="color:var(--warmOrange);" [mat-dialog-close]="oldData" >{{'cancel' | translate}}</button>
  <button mat-button class="orange-button" [disabled]="contentDialogForm.invalid" (click)="onSave();"  >{{'apply' | translate}}</button>
</mat-dialog-actions>
